
import { useEffect, useState } from 'react';
import { api } from '@/lib/api/client';
import { User } from '@/types';

export function useDefaultAdmin() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function setupDefaultAdmin() {
      try {
        setIsLoading(true);
        setError(null);

        // Check if any users exist
        const users = await api.get<User[]>('/users');
        
        if (!users || users.length === 0) {
          // Create default admin user
          await api.post('/users', {
            phoneNumber: '0500000000',
            password: '123456',
            role: 'admin',
            permissions: ['*']
          });
        }
      } catch (error) {
        console.error('Failed to setup default admin:', error);
        setError('فشل إعداد المستخدم الافتراضي');
      } finally {
        setIsLoading(false);
      }
    }

    setupDefaultAdmin();
  }, []);

  return { isLoading, error };
}
